<template>
	<div class="page">
		<MainHeader v-bind:page="'Scholing'"></MainHeader>
		<div class="container">
			<div class="row">
				<div class="whole component">
					<img :src="headerImage" width="938px" />
					<h1>Module Communicatie en Counseling met het Talentenspel</h1>
					<p class="highlight">Persoonlijke supervisie is een verplicht onderdeel in de opleiding, dit traject is voor de ondersteuning en ontwikkeling van het persoonlijke groeiproces en loopt samen met Communicatie en Counseling (8 dagen), Talentenspel (4 dagen) en Vakdagen als een rode draad door de opleiding. Voor het vak van Professioneel Kinesioloog hebben we uiteindelijk vele kwaliteiten, vaardigheden en competenties nodig.</p>
					
					<p class="highlight">
						Tijdelijk neemt Marjon te Riele de trainingen en bijscholingen voor Topki over. Meer informatie op haar
						<a href="https://www.topki.nl/trainer/marjon-te-riele">Topki pagina</a>
					</p>
				
					<h2>Vier losse modules van het Talentenspel</h2>
					<p>Het Talentenspel is leidraad binnen deze vier verschillende modules die aansluitend na elkaar te volgen zijn voor de student tijdens in opleiding. Tijdens deze dagen zal de student verder ingaan op zijn of haar talenten, leiderschap, missie en manifestatie. Hierdoor wordt een bijdrage geleverd aan de Kinesioloog in opleiding en hoe zijn of haar praktijk vanuit het authentieke profiel kan worden vormgegeven.</p>
				</div>
			</div>
			<div class="row">
				<div class="half component">
					<h2>Dag 1: <br>Talenten ontmoeten</h2> 
					<p><b>Het Wereldbord:</b> Harmonisatie en integratie Het spelen van dit bord zorgt vooral voor innerlijke schoonmaak. Vervorming van talenten worden opgespoord en gezond gemaakt. De positie van de koning(in) wordt verhelderd en bekrachtigd.</p>
					<h2>Dag 2: <br>De Levensboom </h2>
					<p><b>Het Levensboombord:</b> Inzicht in richting en hiërarchie Het spelen van dit bord zorgt vooral voor uitzicht op de richting van het leven. Je krijgt inzicht op je pad en je doel ofwel je missie, en richtingsgevoel.</p>
				</div>
				<div class="half component">
					<h2>Dag 3: <br>De Piramide </h2>
					<p><b>Het Piramidebord:</b> Manifestatie en Creatie Het spelen van dit bord voegt een volgende fase toe aan het proces. Dit bord brengt de missie op aarde, het bord van incarnatie, concrete manifestatie van de missie in het dagelijkse leven.</p>
					<h2>Dag 4: <br>De Zielespiegel </h2>
					<p><b>Het Zielespiegelbord:</b> Instrumentatie en zelfrealisatie Het spelen van dit bord brengt de verschillende innerlijke niveaus van de mens bijeen. Men gaat ontdekken dat de missie niet vanuit een drang tot doen kan worden vormgegeven, maar alleen als een spontane uitdrukking van zijn.</p>
				</div>
			</div>

			<div class="row">
				<div class="quarter component">
					<img :src="wereldBord" class="gameboard-small" />
				</div>
				<div class="quarter component">
					<img :src="levensboomBord" class="gameboard-small" />
				</div>
				<div class="quarter component">
					<img :src="piramideBord" class="gameboard-small" />
				</div>
				<div class="quarter component">
					<img :src="zielespiegelBord" class="gameboard-small" />
				</div>
			</div>

			<div class="row">
				<div class="whole component">
					<h2>Accreditatie</h2>
					<p>De beroepsopleiding <a href="http://www.topki.nl/trainer/suzette-frijters">TOPKI</a> is door de SNRO geaccrediteerd. Voor deze beroepsopleiding verzorg ik een aantal scholingsprogramma’s. </p>
					<p>De beroepsopleiding TOPKI voldoet aan de internationale voorwaarden van het International Kinesiology College en werkt samen met verschillende nationale- en internationale trainers. In 2012 is de opleiding erkend door de FONG op HBO-niveau. Sinds 2017 heeft de beroepsopleiding TOPKI het keurmerk: FONG.SNRO erkende HBO-opleiding.</p>
                </div>
            </div>
		</div>
		<MainFooter style="display:flex; margin-left: auto; margin-right:auto;"></MainFooter>
	</div>
</template>

<script>
import MainHeader from '../MainHeader';
import MainFooter from '../MainFooter';

export default {
	name: 'Module-Communicatie-Counseling',
	data() {
		return {
			headerImage: require('../../img/module_communicatie_counseling_header.jpg'),
			wereldBord: require('../../img/wereldbord_nl.jpg'),
			levensboomBord: require('../../img/levensboombord_nl.jpg'),
			piramideBord: require('../../img/piramidebord_nl.jpg'),
			zielespiegelBord: require('../../img/zielespiegelbord_nl.jpg')
		}
	},
	computed: {
	},
	methods: {
	},
	components: {
		MainHeader, MainFooter
	}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ModuleCommunicatieCounseling.vue